// Skip links fix for webkit browsers
// https://humanwhocodes.com/blog/2013/01/15/fixing-skip-to-content-links/
window.addEventListener("hashchange", function(event) {
    var element = document.getElementById(location.hash.substring(1));

    if (element) {
        if (!/^(?:a|select|input|button|textarea)$/i.test(element.tagName)) {
            element.tabIndex = -1;
        }
        element.focus();
    }
}, false);

// Empty callback added as google map required callback function
window.__googleMapsCallback = () => {};
if (!navigator.cookieEnabled) {
    alert('Cookies are blocked by your browser. Kindly enable cookies to continue.');
}
